import React, { useState, useMemo, useEffect, use } from "react";
import { useSearchParams } from "react-router-dom";
import "../../assets/css/article/ArticleRecherche.css";
import ArticleCarte from "../../components/article/ArticleCarte";
import ArticleBanner from "../../components/article/ArticleBanner";
import { imageArticleUrl } from "../../utils/modules";
import { villesMadagascar } from "../../constant/villesMadagascar";
import useArticles from "../../hooks/useArticle";
import useCategorie from "../../hooks/useCategorie.js";
import LoaderArticle from "../../components/loader/article/LoaderArticle.jsx";
import { faqList } from "../../constant/faqListe.js";
import FaqCategorie from "../../components/faqHelmet/FaqCategorie.jsx";
import { Helmet } from "react-helmet-async";
import LoaderDetailAnnonce from "../../components/loader/article/LoaderDetailAnnonce.jsx";

const ArticleRecherche = () => {
  const [searchParams] = useSearchParams();
  const idCategorie = searchParams.get("idCategorie") || "";
  const idGroupeCategorie = searchParams.get("idGroupeCategorie") || "";
  const categorie = searchParams.get("categorie") || "";
  const query = searchParams.get("query") || "";
  const [randomSeed] = useState(() => Date.now());
  const [openIndex, setOpenIndex] = useState(null);
  const [articles, setArticles] = useState([]);
  const [resultFaq, setResultFaq] = useState(null);
  const [categorieSelected, setCategorieSelected] = useState(null);
  const itemsPerPage = 10;
  const [filters, setFilters] = useState({
    titre: "",
    ville: "",
    min: "",
    max: "",
    etat: "",
    typeOffre: "",
    typeAbonnement: "",
    orderByDate: "",
    onlyPremium: false,
    randomSeed: randomSeed,
    status: 1,
    archive: 2,
    userStatus: 1,
    userActive: 1,
    userArchive: 2,
    adminApprouved: 1,
    // dateExpirationAfter: new Date().toISOString(),
    limit: itemsPerPage,
    categorieId: "",
    excludeTest: 1,
  });
  const [page, setPage] = useState(1);
  const [loadingArticle, setLoadingArticle] = useState(false);
  const [numeroComponent, setNumeroComponent] = useState(8);
  const defaultImage = `${imageArticleUrl}/files/article/default-image.png`;
  const [loadingVersDetails, setLoadingVersDetails] = useState(false);
  const {
    findAllArticlesForCategory,
    totalPages,
    findAllArticlesGroupeedShuffled,
  } = useArticles();
  const { getOneCategorie } = useCategorie();
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (idCategorie) {
      setLoadingArticle(true);
      getOneCategorie(idCategorie)
        .then(({ data }) => {
          if (data?.data) {
            setCategorieSelected(data?.data);
            setNumeroComponent(data?.data?.numeroComponent || 8);
            setLoadingArticle(false);
          }
        })
        .catch((err) => {
          console.error(
            "Erreur lors de la récupération de la catégorie :",
            err,
          );
          setLoadingArticle(false);
        });
    }
  }, [idCategorie]);

  useEffect(() => {
    if (categorie) {
      setNumeroComponent(+categorie);
    }
  }, [categorie]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      query: query,
      categorieId: idCategorie,
      status: 1,
      archive: 2,
      userStatus: 1,
      userActive: 1,
      userArchive: 2,
      adminApprouved: 1,
      // dateExpirationAfter: new Date().toISOString(),
      limit: itemsPerPage,
      randomSeed: randomSeed,
      excludeTest: 1,
    }));
    setArticles([]);
    setPage(1);
    setLoadingArticle(true);
    findAllArticlesGroupeedShuffled(1, {
      ...filters,
      query: query,
      categorieId: idCategorie,
      categorieGroupeId: idGroupeCategorie,
      categorie: +categorie,
    })
      .then(({ data }) => {
        setArticles(data);
        if(data && data.length > 0) {
          if(data[0]?.groupeCategorie?.numeroComponent) {
            setNumeroComponent(data[0]?.groupeCategorie?.numeroComponent);
          }
        }
        setLoadingArticle(false);
      })
      .catch((err) => {
        setArticles([]);
        console.error("Erreur lors de la récupération des articles :", err);
        setLoadingArticle(false);
      });
  }, [idCategorie, query, randomSeed]);

  const loadMore = async () => {
    const nextPage = page + 1;

    const params = {
      ...filters,
      categorieId: idCategorie,
      categorieGroupeId: idGroupeCategorie,
      categorie: +categorie,
      query: query,
      randomSeed: randomSeed,
    };

    const { data } = await findAllArticlesGroupeedShuffled(nextPage, params);

    if (!data || data.length === 0) return;

    setArticles((prev) => [...prev, ...data]);
    setPage(nextPage);
  };

  useEffect(() => {
    setOpenIndex(null);
  }, [idCategorie, query]);

  const selectedFaq = (listeArticle) => {
    const listeFaq =
      faqList.find(
        (f) => f.id == listeArticle[0]?.idCategorie?.idCategorieGroupe,
      ) || null;
    setResultFaq(listeFaq);
    return listeFaq;
  };

  const filtered = useMemo(() => {
    if (articles && articles.length > 0) {

      const minPrice = filters.min !== "" ? Number(filters.min) : null;
      const maxPrice = filters.max !== "" ? Number(filters.max) : null;

      let data =
        articles?.filter((a) => {
          const prix = Number(a.prix);
          const prixValide = Number.isFinite(prix);

          return (
            (!filters.ville || a.ville === filters.ville) &&
            (minPrice === null || (prixValide && prix >= minPrice)) &&
            (maxPrice === null || (prixValide && prix <= maxPrice)) &&
            (!filters.etat || String(a.etat) === filters.etat) &&
            (!filters.typeOffre || String(a.typeOffre) === filters.typeOffre) &&
            (!filters.onlyPremium || a.typeAbonnement === 1)
          );
        }) || [];

      if (filters.orderByDate === "asc") {
        data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      } else if (filters.orderByDate === "desc") {
        data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      }

      if (data && data.length > 0) {
        selectedFaq(data);
      }
      return data;
    }
    return [];
  }, [articles, filters]);

  if (loadingVersDetails) {
    return (
      <div className="container">
        <LoaderDetailAnnonce />
      </div>
    );
  }

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      ville: "",
      min: "",
      max: "",
      etat: "",
      typeOffre: "",
      orderByDate: "",
      onlyPremium: false,
    }));
  };

  return (
    <>
      {idCategorie && categorieSelected && (
        <Helmet>
          <title>
            Acheter {categorieSelected?.nom} au meilleur prix | Deal.mg
          </title>
          <meta
            name="description"
            content={`Découvrez nos ${categorieSelected?.nom} disponibles à Madagascar sur Deal.mg`}
          />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/",
              "@type": "Product",
              name: categorieSelected?.nom,
              image: ["https://deal.mg/logo.png"],
              description: `Découvrez nos ${categorieSelected?.nom} disponibles à Madagascar sur Deal.mg`,
              sku: categorieSelected?._id,
              offers: {
                "@type": "Offer",
                url: `https://deal.mg/article/resultat?idCategorie=${categorieSelected?._id}`,
                availability: "https://schema.org/InStock",
              },
            })}
          </script>
        </Helmet>
      )}

      <div className="container">
        {loadingArticle ? (
          <>
            <LoaderArticle />
          </>
        ) : (
          <>
            <ArticleBanner />
            <div className="article_recherche_filter">
              <div className="article_recherche_filter_item">
                <div class="input-group mb-3">
                  <label
                    class="input-group-text article_recherche_icon_localisation"
                    for="inputGroupSelect01"
                  >
                    <i class="bi bi-geo-alt-fill"></i>
                  </label>
                  <select
                    className="form-select"
                    id="inputGroupSelect01"
                    name="ville"
                    value={filters.ville}
                    style={{ borderLeft: "none" }}
                    onChange={(e) => {
                      handleFilterChange("ville", e.target.value);
                    }}
                  >
                    <option value="">Choisir une ville</option>

                    {[...villesMadagascar].sort().map((ville, index) => (
                      <option key={index} value={ville}>
                        {ville}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="article_recherche_filter_item price">
                <div className="input-group">
                  <input
                    type="number"
                    name="prix"
                    value={filters.min}
                    placeholder="Prix min"
                    onChange={(e) => handleFilterChange("min", e.target.value)}
                    className="form-control"
                    style={{ height: "50px" }}
                    pattern="[0-9]*"
                  />
                  <span
                    className="input-group-text"
                    style={{ height: "50px", borderRadius: "0 15px 15px 0" }}
                  >
                    MGA
                  </span>
                </div>

                <div className="input-group">
                  <input
                    type="number"
                    name="prix"
                    value={filters.max}
                    placeholder="Prix max"
                    onChange={(e) => handleFilterChange("max", e.target.value)}
                    className="form-control"
                    style={{ height: "50px" }}
                    pattern="[0-9]*"
                  />
                  <span
                    className="input-group-text"
                    style={{ height: "50px", borderRadius: "0 15px 15px 0" }}
                  >
                    MGA
                  </span>
                </div>
              </div>

              <div className="article_recherche_filter_item dropdowns">
                {/* ÉTAT */}
                <div className="btn-group dropend">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {filters.etat === "1"
                      ? "Neuf"
                      : filters.etat === "2"
                        ? "Occasion"
                        : "État"}
                  </button>
                  <ul className="dropdown-menu menu_search">
                    <li
                      className="dropdown-item"
                      onClick={() => handleFilterChange("etat", "1")}
                    >
                      Neuf
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => handleFilterChange("etat", "2")}
                    >
                      Occasion
                    </li>
                    <li
                      className="dropdown-item text-muted"
                      onClick={() => handleFilterChange("etat", "")}
                    >
                      Tous
                    </li>
                  </ul>
                </div>

                {/* TYPE */}
                <div className="btn-group dropend">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {filters.typeOffre === "1"
                      ? "Offre"
                      : filters.typeOffre === "2"
                        ? "Demande"
                        : "Type"}
                  </button>
                  <ul className="dropdown-menu menu_search">
                    <li
                      className="dropdown-item"
                      onClick={() => handleFilterChange("typeOffre", "1")}
                    >
                      Offre
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => handleFilterChange("typeOffre", "2")}
                    >
                      Demande
                    </li>
                    <li
                      className="dropdown-item text-muted"
                      onClick={() => handleFilterChange("typeOffre", "")}
                    >
                      Tous
                    </li>
                  </ul>
                </div>

                {/* DATE */}
                <div className="btn-group dropend">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {filters.orderByDate === "desc"
                      ? "Plus récentes"
                      : filters.orderByDate === "asc"
                        ? "Plus anciennes"
                        : "Date"}
                  </button>
                  <ul className="dropdown-menu menu_search">
                    <li
                      className="dropdown-item"
                      onClick={() => handleFilterChange("orderByDate", "desc")}
                    >
                      Plus récentes
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => handleFilterChange("orderByDate", "asc")}
                    >
                      Plus anciennes
                    </li>
                  </ul>
                </div>
                <button
                  className="btn btn-dark"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Réinitialiser
                </button>
              </div>
            </div>
            <div className="results_title">
              <h1 className="result_text">Résultats recherches</h1>
            </div>
            {filtered && filtered.length == 0 ? (
              <div className="no_result_container">
                <h3>Aucun résultat trouvé</h3>
                <p>
                  Essayez de modifier vos critères de recherche ou vos filtres.
                </p>
              </div>
            ) : (
              <div className="article_recherche_results">
                {filtered &&
                  filtered.map((a, index) => (
                    <ArticleCarte
                      key={a._id || index}
                      article={a}
                      imageUrl={
                        a.photos?.[0]
                          ? `${imageArticleUrl}/${a.photos[0]}`
                          : defaultImage
                      }
                      setLoadingVersDetails={setLoadingVersDetails}
                    />
                  ))}
              </div>
            )}
            {filtered && filtered.length > 0 && page < totalPages && (
              <div className="pagination-loadmore">
                <button onClick={loadMore} className="btn-loadmore">
                  Voir plus
                </button>
              </div>
            )}

            <FaqCategorie numeroComponent={numeroComponent} />
          </>
        )}
      </div>
    </>
  );
};

export default ArticleRecherche;
